import { mount } from "svelte";
import routes from "./routes.json";
import { loaders } from "./routes-loader.js";
import { resolveNavigation, redirectToLogin, setRoutes } from "./authGuard";
import NavigationStatus from "./NavigationStatus.svelte";
import { startTransfers } from "./transfers/client";

const pageTarget = document.getElementById("page");
const menuTarget = document.getElementById("menu");
const norm = (p) => (p || "/").replace(/\/+$/, "") || "/";

setRoutes(routes);
// Independent of the selected feature, its menu, and the transfers overview.
void startTransfers();

function clearTarget(target) {
  if (target) target.innerHTML = "";
}

async function loadComponent(modulePath) {
  const load = loaders[modulePath];
  if (!load) {
    console.error("No loader for module", modulePath);
    return null;
  }
  const mod = await load();
  return mod.default;
}

async function boot() {
  const path = norm(window.location.pathname);

  const result = await resolveNavigation(path);
  if (result.kind === "login") {
    redirectToLogin();
    return;
  }
  clearTarget(pageTarget);
  clearTarget(menuTarget);
  if (result.kind !== "allowed") {
    mount(NavigationStatus, { target: pageTarget, props: { kind: result.kind } });
    return;
  }
  const route = result.route;
  if (path === "/") history.replaceState({}, "", route.href);

  if (route.menuModulePath) {
    const MenuComp = await loadComponent(route.menuModulePath);
    if (MenuComp) {
      mount(MenuComp, { target: menuTarget, props: {} });
    }
  }

  const PageComp = await loadComponent(route.modulePath);
  if (!PageComp) {
    pageTarget.textContent = "Route not found.";
    return;
  }

  mount(PageComp, {
    target: pageTarget,
    props: {}
  });

  try {
    if (sessionStorage.getItem("huckleberry.start-page-fallback")) {
      sessionStorage.removeItem("huckleberry.start-page-fallback");
      const notice = document.createElement("div");
      notice.setAttribute("role", "status");
      notice.textContent = "Die gewünschte Seite ist nicht verfügbar. Deine Startseite wurde geöffnet.";
      Object.assign(notice.style, {
        position: "fixed", bottom: "max(16px, env(safe-area-inset-bottom))", left: "16px", right: "16px",
        maxWidth: "32rem", margin: "auto", padding: "12px 16px", borderRadius: "12px",
        background: "#172033", color: "#fff", zIndex: "1100", fontSize: "14px",
      });
      document.body.append(notice);
      setTimeout(() => notice.remove(), 6000);
    }
  } catch { /* optional notice; navigation works without session storage */ }
}

void boot();
// Revalidate back/forward and bfcache restores through the same entry point.
window.addEventListener("popstate", () => location.reload());
window.addEventListener("pageshow", event => { if (event.persisted) location.reload(); });
